import { FormEvent } from "react";

import { getDatabase, ref, child, push, update } from "firebase/database";
import { RunMethods } from '../store/runs-context';
import Run from '../types/run';


export const handleSubmit =  async ({ event, run, runsContext, onSuccess, onError }: {event: FormEvent<HTMLFormElement>, run: Run, runsContext: any, onSuccess: any, onError: any}) => {
  const globalWindow = (window as any);
  event.preventDefault();
  let state: Run = JSON.parse(JSON.stringify(run));
 
  const db = getDatabase(globalWindow.firebaseApp);
  // const cleanUpState = JSON.parse(JSON.stringify(state));
  // Get a key for a new Run.
  let endpointKey;
  let contextMethod: RunMethods;
  if(run._id) {
    endpointKey = run._id;
    contextMethod = RunMethods.updateRun;
  } else {
    endpointKey = push(child(ref(db), 'run')).key;
    state._id = endpointKey as string;
    contextMethod = RunMethods.addRun;
  }
  const updates = {};
  const runName  = `/run/${endpointKey}`;
  (updates as any)[runName] = state;
  update(ref(db), updates).then(result => {
    onSuccess?.();
    if (runsContext) {
      switch(contextMethod) {
        case RunMethods.addRun:
          runsContext.addRun?.(state);
          break;
        case RunMethods.updateRun:
          runsContext.updateRun?.(state);
          break;
        default:
          console.warn(`[debug] No proper method (add or update) for the Form submit`);
      }
    }
  }).catch(error => {
    console.warn(`Error adding a new run: ${error}`);
    onError?.();
  });
};